let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kpRuP")).then(() => parcelRequire('8ragj'));